import { render, staticRenderFns } from "./Abouts.vue?vue&type=template&id=85feb272&scoped=true"
import script from "./Abouts.vue?vue&type=script&lang=js"
export * from "./Abouts.vue?vue&type=script&lang=js"
import style0 from "./Abouts.vue?vue&type=style&index=0&id=85feb272&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85feb272",
  null
  
)

export default component.exports